import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { EMPTY, Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';
import { DangerousGoodItem } from '../../models/dangerous-good-item.model';
import { TransportMode } from '../../models/transport-mode.enum';
import { DangerousGoodService } from '../../services/dangerous-good.service';
import { LanguageService } from '../../services/language.service';
import { ArticleItem } from '../../models/article-item.model';

@Component({
  selector: 'hazmatsuite-next-dangerousgood-selection',
  templateUrl: './dangerousgood-selection.component.html',
  styleUrls: ['./dangerousgood-selection.component.scss'],
})
export class DangerousgoodSelectionComponent {
  @Input() showCancelButton = false
  @Input() showLoadFromArticles = false
  @Input() transportMode = TransportMode.Unknown;
  @Input() excludedDgClasses: number[] = [];
  @Output() selectDangerousGood = new EventEmitter<DangerousGoodItem>();
  @Output() selectArticleEvent = new EventEmitter<ArticleItem>();

  searchExecuted = false;

  form: FormGroup;
  dangerousGoods$: Observable<DangerousGoodItem[]> = EMPTY;

  searchTranslations$ = this.languageService.translations$.pipe(map(data => data['SearchResource']));
  packingListTranslations$ = this.languageService.translations$.pipe(map(data => data['PackingListResource']));
  dangerousGoodListTranslations$ = this.languageService.translations$.pipe(map(data => data['DangerousGoodListResource']));
  validationResource$ = this.languageService.translations$.pipe(map(data => data['ValidationResource']));

  constructor(private fb: FormBuilder, private dgService: DangerousGoodService, private languageService: LanguageService) {
    this.languageService.fetchResources(['PackingListResource', 'SearchResource', 'DangerousGoodListResource', 'ValidationResource'])
    this.form = fb.group({
      unNumber: new FormControl('', { updateOn: 'change' }),
      properShippingName: new FormControl('', { validators: [Validators.required], updateOn: 'change' }),
    });
  }

  identify(index: number, item: DangerousGoodItem) {
    return item.ID;
  }

  selectDg(item: DangerousGoodItem): void {
    this.selectDangerousGood.next(item);
  }

  selectArticle(article: ArticleItem): void {
    this.selectArticleEvent.next(article);
    this.dgService.getDangerousGood(article.DgId ?? 0, this.transportMode)
      .pipe(take(1)).subscribe(dg => this.selectDangerousGood.next(dg));
  }

  searchProperShippingName(): void {
    if (!this.properShippingName?.valid) {
      return this.properShippingName?.markAsTouched();
    }

    this.dangerousGoods$ = this.dgService.getDangerousGoodsList(this.properShippingName?.value, this.transportMode, this.excludedDgClasses).pipe(tap((result: DangerousGoodItem[]) => {
      this.searchExecuted = true;
      if (result.length === 1) {
        return this.selectDg(result[0]);
      }
    }));
  }

  unNumberChanged(evt: any): void {
    if (evt.target?.value?.trim().length >= 4) {
      this.dangerousGoods$ = this.dgService.getDangerousGoodsList(evt.target?.value.trim(), this.transportMode, this.excludedDgClasses).pipe(tap((result: DangerousGoodItem[]) => {
        this.searchExecuted = true;
        if (result.length === 1) {
          return this.selectDg(result[0]);
        }
      }));
    }
  }

  get properShippingName(): AbstractControl | null {
    return this.form.get('properShippingName');
  }
}
